// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".account-modification-container {\n  min-height: calc(100vh - 4rem);\n  background-color: #F9E7D5;\n}", "",{"version":3,"sources":["webpack://src/scenes/accountModification/styles.scss"],"names":[],"mappings":"AAAA;EAEI,8BAAA;EACA,yBAAA;AAAJ","sourcesContent":[".account-modification-container {\n    //min-height: 91.5vh;\n    min-height: calc(100vh - 4rem);\n    background-color: #F9E7D5;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
